/*
    Рандомные иконки на первом экране главной страницы
*/

function randomizeIcons(container, icons, effectClass) {
    let $container = $(container);
    let $icons = $(icons);

    let iconsUrls = $.makeArray($icons).map(function(icon) {
        return $(icon).attr('src').split("/").reverse()[0];
    });

    if (window.randomMainIcons) {
        let array = window.randomMainIcons;
        $container.addClass(effectClass).addClass('_hidden'); 

        // Cлучайное изображение

        let flag = 1;
        let url, urlName, double;
        // Выбираем изображение, чтобы не было повторений
        while (flag) {
            url = array[ Math.floor(Math.random() * array.length) ];
            urlName = url.split("/").reverse()[0];
            double = (iconsUrls.filter((el) => el.toLowerCase().indexOf(urlName.toLowerCase()) > -1)).length;
            if (double === 0) {
                flag = 0;
            }
        };
        // Подставляем изображение
        setTimeout(function() {
            $container.attr('src', url);
            $container.removeClass('_hidden');
        }, 200);
    }
}

function getRandomArrayItem(array, prevValue) {
    if (!array || !array.length) {
        throw new Error('Array must not be empty');
    }

    if (array.length === 1) {
        return array[0];
    }

    do {
        let value = array[Math.floor(Math.random() * array.length)];

        // на мобилке иконки у длинных строчек скрыты
        // проверяем, не меняем скрытую и выбираем дальше
        if (getOrientation() === "Portrait" && App.W.width() < 768 && $(value).parents('.mp-hero__line--big').length) {
            // console.log(value);
            value = prevValue;
        } 

        if (value !== prevValue) {
            return value;
        }

    } while(true);
}

function getOrientation() {
    var orientation = window.innerWidth > window.innerHeight ? "Landscape" : "Portrait";
    return orientation;
}

App.W.on('barba:afterEnter', () => {
    let iconsArr = App.H.find('.js-random-icon');
    let effects = ['_left', '_rotate', '_scale', '_scaleX'];
    
    let prevIcon = '';
    let prevEffect = '';

    if (window.randomMainIcons) {
        let array = window.randomMainIcons;
        $.each( array, function( index, value ){
            $('.js-preload-main-icons').append('<img src="' + value + '" alt="CP">');
        });
    }

    if (iconsArr.length) {
        setInterval(function() {
            $('.js-random-icon').removeClass('_left _rotate _scale _scaleX');        
            // $('.js-random-icon').removeClass('_left _rotate _scale _scaleX');        

            // Выбираем случайный эффект, отличный от предыдущего
            const effectClass = getRandomArrayItem(effects, prevEffect);
            prevEffect = effectClass;
            // Выбираем строчку, отличную от предыдущей
            const icon = getRandomArrayItem(iconsArr, prevIcon);
            prevIcon = icon;

            randomizeIcons(icon, iconsArr, effectClass);
        }, 6000);
    }
});



// WEBPACK FOOTER //
// ./_src/js/modules/RandomMainIcons.js